// Redux Store

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import supervisorReducer from './slices/supervisorSlice';
import salespersonReducer from './slices/salespersonSlice';
import analyticsReducer from './slices/analyticsSlice';
import inquiryReducer from './slices/inquirySlice';
import salespersonAnalyticsReducer from './slices/salespersonAnalyticsSlice';
import templatesReducer from './slices/templatesSlice';
// import whatsappReducer from './slices/whatsappSlice';
import customerReducer from './slices/customerSlice';
import stockReducer from './slices/stockSlice';
import expensesReducer from './slices/expensesSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    supervisors: supervisorReducer,
    salespersons: salespersonReducer,
    analytics: analyticsReducer,
    inquiries: inquiryReducer,
    salespersonAnalytics: salespersonAnalyticsReducer,
    templates: templatesReducer,
    // whatsapp: whatsappReducer,
    customers: customerReducer,
    stocks: stockReducer,
    expenses: expensesReducer,
  },
});

export default store;
